import React, { useCallback, useEffect, useRef, useState } from "react";
import Modal from "./Modal";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NotificationIcon from "../../assets/icons/icon-notifications.svg";
import ProfileImg from "../../images/profile.png";
import DeclineIcon from "../../images/decline-call.png";
import AttendVoiceIcon from "../../images/attend-voice.png";
import AttendVideoIcon from "../../images/attend-video.png";
import HamburgerIcon from "../../images/hamburger-icon.png";
import { logout } from "../Redux/Authentication";
import _ from "lodash";
// import { checkFileExists } from "../../utils/generic";

const Header = (props) => {
  const url = process.env.REACT_APP_APP_BACK_URL;
  const base_url = process.env.REACT_APP_BASE_URL;
  let idleTimeoutInSeconds = 30; // 5 minutes (adjust as needed)
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [sender, setSender] = useState(null);
  const [getNotification, setNotification] = useState([]);
  const isAuthenticated = useSelector((state) => state.user);
  const [notificationData, setNotificationData] = useState([]);
  const [fileExist, setFileExist] = useState(false);
  function closeModal() {
    setIsOpen(false);
  }
  function joinRoom() {
    setIsOpen(false);
    navigate(`/room/${sender}/?remote=true`);
  }

  useEffect(() => {
    // const checkFileExists = async (img) => {
    //   try {
    //     const response = await fetch(img);
    //     // Check if response is an actual image or contains expected content
    //     if (
    //       response.ok &&
    //       response.headers.get("content-type")?.includes("image")
    //     ) {
    //       setFileExist(true);
    //     } else {
    //       setFileExist(false);
    //     }
    //   } catch (error) {
    //     setFileExist(false);
    //   }
    // };
    getTimer();
    // checkFileExists(`${base_url}/uploads${isAuthenticated?.image}`);
  }, []);

  const idleTimer = useRef(null);
  const lastActivityTime = useRef(Date.now());
  const getTimer = async () => {
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      headers.append("auth-token", localStorage.getItem("token"));
      const response = await fetch(`${url}/api/timeout/getByType/Admin`, {
        mode: "cors",
        method: "GET",
        headers: headers,
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();
      idleTimeoutInSeconds = json.time.time;
    } catch (error) {
      console.error(error);
    }
  };
  const handle_logout = useCallback(async () => {
    await localStorage.removeItem("token");
    dispatch(logout());

    const siteuser = localStorage.getItem("siteuser");
    const loggedIn = localStorage.getItem("loggedIn" || false);
    if(loggedIn === "true") {
    if (siteuser) {
      navigate(`/${siteuser}/pin`);
    } else {
      const siteUserSessions = sessionStorage.getItem("siteuser");
      if (siteUserSessions) {
        navigate(`/${siteUserSessions}/pin`);
      } else {
        navigate(`/`);
      }
    }
    } else {
      navigate(`/login`);
    }
  }, [dispatch, navigate]);

  const resetIdleTimer = useCallback(() => {
    lastActivityTime.current = Date.now();
  }, []);

  useEffect(() => {
    // Debounced activity handler
    const onActivity = _.debounce(() => {
      resetIdleTimer();
    }, 300);

    // Register event listeners for user activity
    const activityEvents = ["mousemove", "keydown", "mousedown", "scroll"];
    activityEvents.forEach((event) => {
      window.addEventListener(event, onActivity);
    });

    // Set up an interval to check for idle state every second
    idleTimer.current = setInterval(() => {
      if (Date.now() - lastActivityTime.current > idleTimeoutInSeconds * 1000) {
        handle_logout();
      }
    }, 1000);

    // Cleanup function
    return () => {
      activityEvents.forEach((event) => {
        window.removeEventListener(event, onActivity);
      });
      onActivity.cancel(); // Cancel debounce to prevent memory leaks
      clearInterval(idleTimer.current); // Clear interval on unmount
    };
  }, [handle_logout, resetIdleTimer]);

  return (
    <>
      <header>
        <div className="row">
          <div className="col-lg-6">
            <div className="wel-not">
              <h1>
                welcome back {isAuthenticated?.name}!{" "}
                <span class="badge bg-primary">{isAuthenticated?.role}</span>
              </h1>
            </div>
          </div>
          <div className="col-lg-6 text-end">
            <div className="prof-sett">
              <div className="mob_btn_hambrgr" onClick={props.toggleActive}>
                <img src={HamburgerIcon} alt="" />
              </div>
              <div className="dropdown">
                <button
                  className="btn dropdown-toggle"
                  type="button"
                  id="dropdownNot"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{
                    position: "relative",
                    ...(notificationData.length > 0 && {
                      paddingRight: "15px", // Adjust the padding to accommodate the indicator
                    }),
                  }}
                >
                  <img src={NotificationIcon} alt="" />
                  {notificationData.length > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        width: "10px",
                        height: "10px",
                        backgroundColor: "red",
                        borderRadius: "50%",
                      }}
                    ></span>
                  )}
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownNot">
                  <li className="notification_heads">
                    <div className="not_head_wrap">
                      <h3 className="not_head">notifications</h3>
                    </div>
                    <div className="not_num">
                      <span className="not_num_icon">
                        {notificationData.length}
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="prof-wrap">
                <div className="det-prof">
                  <div className="name-wrap">
                    <h5 className="mb-0">{isAuthenticated?.name}</h5>
                    <p>{isAuthenticated?.email}</p>
                  </div>
                </div>
                <div className="prof-img">
                  {isAuthenticated?.image ? (
                    <Link to="/profile">
                      <div className="img-profile-wrap">
                        <img
                          src={
                            isAuthenticated?.image
                              ? `/uploads/${isAuthenticated?.image}`
                              : ProfileImg
                          }
                          onError={(e) => {
                            e.target.src = "/placeholder.png";
                          }}
                          style={{
                            height: "50px",
                            width: "50px",
                            borderRadius: "5px",
                          }}
                        />
                      </div>
                    </Link>
                  ) : (
                    <Link to="/profile">
                      <img src={'/placeholder.png'} alt="" style={{
                        height: "50px",
                        width: "50px",
                        borderRadius: "5px",
                      }} />
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <Modal isOpen={modalIsOpen} onClose={closeModal}>
        <div className="modal-body">
          <div className="row h-100">
            <div className="col-12 mt-auto">
              <div className="incoming-call-sec">
                <h3 className="text-center">Inviting you for a video chat</h3>
                <div className="call-detail-bar">
                  <div className="call-options-wrap">
                    <div className="icons-wrap-options">
                      <div className="icon-dec">
                        <img src={DeclineIcon} alt="" onClick={closeModal} />
                      </div>
                      <div className="icon-att-voice">
                        <img src={AttendVoiceIcon} alt="" onClick={joinRoom} />
                      </div>
                      <div className="icon-att-vid">
                        <img src={AttendVideoIcon} alt="" onClick={joinRoom} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default Header;
